import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from '../ui/Button';

const GameFlowNavigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isGameArena = location?.pathname === '/game-arena';
  const isAIMoodSelection = location?.pathname === '/ai-mood-selection';

  const gameStats = {
    currentRound: 5,
    score: 850,
    aiMood: 'Aggressive',
    timeRemaining: 45,
  };

  const handleChangeAIMood = () => {
    navigate('/ai-mood-selection');
    setIsMenuOpen(false);
  };

  const handleReturnToMenu = () => {
    navigate('/main-menu');
    setIsMenuOpen(false);
  };

  const handleViewStats = () => {
    navigate('/gem-collection');
    setIsMenuOpen(false);
  };

  const handleStartGame = () => {
    navigate('/game-arena');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  if (!isGameArena && !isAIMoodSelection) {
    return null;
  }

  return (
    <>
      <div className="game-flow-navigation fixed bottom-4 right-4 z-[75] lg:bottom-8 lg:right-8">
        <button
          onClick={toggleMenu}
          className="w-14 h-14 lg:w-16 lg:h-16 rounded-sm bg-secondary border-2 border-secondary shadow-glow-magenta-md hover:shadow-glow-magenta-lg transition-all duration-base touch-target flex items-center justify-center hover:scale-105"
        >
          <Icon 
            name={isMenuOpen ? 'X' : 'Menu'} 
            size={28} 
            color="var(--color-secondary-foreground)" 
          />
        </button>

        {isMenuOpen && (
          <div className="absolute bottom-full right-0 mb-sm w-64 bg-card border-2 border-secondary rounded-sm shadow-glow-magenta-lg p-lg">
            <div className="space-y-md">
              <div className="pb-sm border-b border-secondary/30">
                <h3 className="font-heading font-semibold text-secondary mb-xs">Game Menu</h3>
                {isGameArena && (
                  <div className="space-y-xs text-sm font-caption">
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">Round:</span>
                      <span className="text-primary font-data">{gameStats?.currentRound}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">Score:</span>
                      <span className="text-accent font-data">{gameStats?.score}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">AI Mood:</span>
                      <span className="text-secondary font-data">{gameStats?.aiMood}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className="space-y-sm">
                {isGameArena && (
                  <Button
                    variant="outline"
                    size="default"
                    iconName="Brain"
                    iconPosition="left"
                    onClick={handleChangeAIMood}
                    fullWidth
                  >
                    Change AI Mood
                  </Button>
                )}

                {isAIMoodSelection && (
                  <Button
                    variant="default"
                    size="default"
                    iconName="Gamepad2"
                    iconPosition="left"
                    onClick={handleStartGame}
                    fullWidth
                  >
                    Start Game
                  </Button>
                )}

                <Button
                  variant="outline"
                  size="default"
                  iconName="Trophy"
                  iconPosition="left"
                  onClick={handleViewStats}
                  fullWidth
                >
                  View Stats
                </Button>

                <Button
                  variant="secondary"
                  size="default"
                  iconName="Home"
                  iconPosition="left"
                  onClick={handleReturnToMenu}
                  fullWidth
                >
                  Return to Menu
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      {isMenuOpen && (
        <div 
          className="fixed inset-0 z-[74] bg-background"
          onClick={toggleMenu}
        />
      )}
    </>
  );
};

export default GameFlowNavigation;